import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "../../wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";

const actionTexts = [
	"background:bauhaus interior",
	"\ntitle: A Bauhaus Interior",
	"\n  shadow:over-image",
	"\ntitle:>>>Animate>>>Some>>>Text<<<\n  shadow:over-image",
];

const fx: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.fxTitle}</strong>} />
		),
		position: "center",
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent description={() => text.tourSteps.fxHardToRead} />
		),
		position: "center",
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: "", prefill: actionTexts[0] + actionTexts[1] });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						We can type <span className="qp-tour-modifier">shadow:</span> and
						select
						<span className="qp-tour-keyword"> over-image</span> {text.tourSteps.fxShadowSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			typeSomeText({ text: actionTexts[2] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						Type <span className="qp-tour-modifier">{">>>"}</span> {text.tourSteps.fxAnimateSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			typeSomeText({ text: actionTexts[3] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.fxEndAnimation}{" "}
						<span className="qp-tour-modifier">{"<<<"}</span>
					</span>
				)}
			/>
		),
	},
	{
		selector: ".present-control",
		content: () => (
			<TourStepContent description={() => text.tourSteps.fxClickPlay} />
		),
	},
];

export default fx;
